import {fromJS} from "immutable";

export function getAllShops() {
  return fromJS([
    {id: "alpine-water-usa-llc", label: "USA"},
    {id: "alpine-water-gmbh", label: "Europe"},
    {id: "alpine-water-schweiz-gmbh", label: "Switzerland"},
    {id: "hallstein-water-canada-inc", label: "Canada"},
    {id: "alpine-water-uk", label: "United Kingdom"},
    {id: "hallstein-water-sg", label: "Singapore"},
  ])
}

export function getAllShopsWithAllOption() {
  return fromJS([
    {id: "", label: "All Shops"},
    {id: "alpine-water-usa-llc", label: "USA"},
    {id: "alpine-water-gmbh", label: "Europe"},
    {id: "alpine-water-schweiz-gmbh", label: "Switzerland"},
    {id: "hallstein-water-canada-inc", label: "Canada"},
    {id: "alpine-water-uk", label: "United Kingdom"},
    {id: "hallstein-water-sg", label: "Singapore"},
  ])
}